import { render, staticRenderFns } from "./VIPMiddleDeatil.vue?vue&type=template&id=3c7d3af6&scoped=true&"
import script from "./VIPMiddleDeatil.vue?vue&type=script&lang=js&"
export * from "./VIPMiddleDeatil.vue?vue&type=script&lang=js&"
import style0 from "./VIPMiddleDeatil.vue?vue&type=style&index=0&id=3c7d3af6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d3af6",
  null
  
)

export default component.exports